import { render, staticRenderFns } from "./Colapse.vue?vue&type=template&id=7f6cb40c&scoped=true"
import script from "./Colapse.vue?vue&type=script&lang=js"
export * from "./Colapse.vue?vue&type=script&lang=js"
import style0 from "./Colapse.vue?vue&type=style&index=0&id=7f6cb40c&lang=scss&scoped=true"
import style1 from "./Colapse.vue?vue&type=style&index=1&id=7f6cb40c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6cb40c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f6cb40c')) {
      api.createRecord('7f6cb40c', component.options)
    } else {
      api.reload('7f6cb40c', component.options)
    }
    module.hot.accept("./Colapse.vue?vue&type=template&id=7f6cb40c&scoped=true", function () {
      api.rerender('7f6cb40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/Colapse.vue"
export default component.exports